'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

function TrackingToggleLink(_ref) {
  let {
    collapsed,
    onClick
  } = _ref;
  const {
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const {
    shippingActivityShowFullHistoryButtonText,
    shippingActivityHideFullHistoryButtonText
  } = nthHookTranslations.useTranslations();
  const handleClick = () => {
    onClick();
  };
  return /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: {
        ...linksNoneDefault,
        display: 'flex'
      },
      sHover: linksNoneHover
    },
    onClick: handleClick
  }, collapsed ? shippingActivityShowFullHistoryButtonText : shippingActivityHideFullHistoryButtonText);
}
function translationsProvider(component) {
  return nthHookTranslations.withTranslationsProvider(component, {
    translationKeys: ['shippingActivityShowFullHistoryButtonText', 'shippingActivityHideFullHistoryButtonText']
  });
}
function themeProvider(component) {
  return nthHookTheme.withThemeProvider(component, {
    themeTokens: ['linksNoneDefault', 'linksNoneHover']
  });
}
var TrackingToggleLink$1 = translationsProvider(themeProvider(TrackingToggleLink));

exports["default"] = TrackingToggleLink$1;
